import { combineReducers } from "redux";
import UserReducer from "./UserReducer";
import GamesDataReducer from "./GamesDataReducer";
import PropertyReducer from "./PropertyReducer";
import SelectPropertyReducer from "./SelectPropertyReducer";
import VendorTypesReducer from "./VendorTypesReducer";
import PartnersReducer from "./PartnersReducer";
import SelectedPartnerReducer from "./SelectedPartnerReducer";
import PendingTasksReducer from "./PendingTasksReducer";
import LocationsReducer from "./LocationsReducer";
import SelectLocationReducer from "./SelectLocationReducer";
import OwnerReducer from "./OwnersReducer";
import StaffReducer from "./StaffsReducer";
import BrokerReducer from "./BrokersReducer";

const rootReducer = combineReducers({
  UserReducer,
  GamesDataReducer,
  PropertyReducer,
  PartnersReducer,
  SelectPropertyReducer,
  SelectedPartnerReducer,
  VendorTypesReducer,
  PendingTasksReducer,
  LocationsReducer,
  SelectLocationReducer,
  OwnerReducer,
  StaffReducer,
  BrokerReducer,
});

export default rootReducer;
